import { defineMessages } from 'react-intl';

export default defineMessages({
    changeRegistration: {
        id: 'qnb.spm.vehicleSummary.changeRegLink',
        defaultMessage: 'Change registration'
    },
    enterRegistration: {
        id: 'qnb.spm.vehicleSummary.enterRegLink',
        defaultMessage: 'Enter registration'
    },
    editVehicle: {
        id: 'qnb.spm.vehicleSummary.editVehicle',
        defaultMessage: 'Edit vehicle details'
    },
});
